import { render, staticRenderFns } from "./CollapsedMailComponent.vue?vue&type=template&id=76605e84"
import script from "./CollapsedMailComponent.vue?vue&type=script&lang=js"
export * from "./CollapsedMailComponent.vue?vue&type=script&lang=js"
import style0 from "./CollapsedMailComponent.vue?vue&type=style&index=0&id=76605e84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports